type CreditCardFlags =
  | 'default'
  | 'visa'
  | 'mastercard'
  | 'diners'
  | 'amex'
  | 'discover'
  | 'hipercard'
  | 'elo'
  | 'jcb'
  | 'aura'
  | 'maestro'
  | 'visaelectron'
  | 'forbrugsforeningen'
  | 'dankort'
  | 'diners'
  | 'unionpay';

export interface CredidCardFlagState {
  name: string;
  flag: CreditCardFlags;
  pattern: RegExp;
  length: number;
  cvcLength: number;
  image: string;
}

export const getCardFlag = (receivedCardNumber: number | string): CredidCardFlagState => {
  var cardNumber = `${receivedCardNumber}`.replace(/[^0-9]+/g, '');

  const cards: CredidCardFlagState[] = [
    {
      name: 'Visa Electron',
      flag: 'visaelectron',
      pattern: /^4(026|17500|405|508|844|91[37])/,
      length: 16,
      cvcLength: 3,
      image: 'visaelectron.png',
    },
    // {
    //   flag: 'maestro',
    //   pattern: /^(5018|5020|5038|6304|6759|6761|6763)[0-9]{8,15}$/,
    //   length: 19,
    //   cvcLength: 3,
    //  image: 'maestro.png'
    // },
    // {
    //   flag: 'forbrugsforeningen',
    //   pattern: /^600/,
    //   length: 16,
    //   cvcLength: 3,
    // },
    // {
    //   flag: 'dankort',
    //   pattern: /^5019/,
    //   length: 16,
    //   cvcLength: 3,
    // },
    {
      name: 'Visa',
      flag: 'visa',
      pattern: /^4[0-9]{0,}$/,
      length: 16,
      cvcLength: 3,
      image: 'visa.png',
    },
    {
      name: 'Mastercard',
      flag: 'mastercard',
      pattern: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$/,
      length: 16,
      cvcLength: 3,
      image: 'mastercard.png',
    },
    {
      name: 'Amex',
      flag: 'amex',
      pattern: /^3[47][0-9]{0,}$/,
      length: 15,
      cvcLength: 4,
      image: 'amex.png',
    },
    {
      name: 'Diners',
      flag: 'diners',
      pattern: /^3(?:0[0-59]{1}|[689])[0-9]{0,}$/,
      length: 14,
      cvcLength: 3,
      image: 'diners.png',
    },
    {
      name: 'Discover',
      flag: 'discover',
      pattern: /^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])[0-9]{0,}$/,
      length: 16,
      cvcLength: 3,
      image: 'discover.png',
    },
    // {
    //   flag: 'unionpay',
    //   pattern: /^(62|88)/,
    //   length: 20,
    //   cvcLength: 3,
    // },
    {
      name: 'JCB',
      flag: 'jcb',
      pattern: /^(?:2131|1800|35)[0-9]{0,}$/,
      length: 16,
      cvcLength: 3,
      image: 'jcb.png',
    },
    {
      name: 'Hipercard',
      flag: 'hipercard',
      pattern: /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
      length: 16,
      cvcLength: 3,
      image: 'hipercard.png',
    },
    {
      name: 'ELO',
      flag: 'elo',
      pattern:
        /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/,
      length: 16,
      cvcLength: 3,
      image: 'elo.png',
    },
    {
      name: 'Aura',
      flag: 'aura',
      pattern: /^(5078\d{2})(\d{2})(\d{11})$/,
      length: 16,
      cvcLength: 3,
      image: 'aura.png',
    },
  ];
  /*
  banes.png
  
  
  hiper.png
  
  
  
  
  
  
*/
  const result = cards.filter((card) => {
    return card.pattern.test(cardNumber);
  });

  if (result.length) {
    return result[0];
  }

  return {
    name: '',
    flag: 'default',
    pattern: new RegExp(''),
    length: 20,
    cvcLength: 4,
    image: '',
  };
};

export default getCardFlag;
